<div class='no-items {{addNewClass}}'>
    <div class='no-items-content'>
      <span class='no-items-icon'>
        <!-- <i class='icon-exclamation'>&nbsp;</i> -->
        <img src="assets/images/noitems.svg" alt="{{'Requisition.noItemsMsg' | translate}}" class="noItemImg">
      </span>
      <span class='no-items-msg'>{{'Requisition.noItemsMsg' | translate}}</span>
    </div>
  </div>